<template>
  <el-dropdown @command="handleCommand" class="dropdown">
    <span class="el-dropdown-link">
      {{ getCommandText }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in this.localesResult" :key="item.country.key" :command="item.country.key">
        {{ item.country.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { LOCALE_STORE_KEY } from '../constant'
import { setLocal, getLocal } from '@meta-vue/util'
export default {
  props: ['localesResult'],
  computed: {
    getCommandText() {
      return this.localesResult.find(item => item.country.key === (this.command || ''))?.country.label || ''
    }
  },
  data() {
    return {
      command: '',
      languageList: [],
      timeZones: [],
      language: '',
      zone: ''
    }
  },
  created() {},
  methods: {
    handleCommand(command) {
      this.command = command
      //切换国家后，更改语言和时区
      const commandInfo = getLocal(LOCALE_STORE_KEY)
      //语言
      this.languageList = this.localesResult.find(item => item.country.key === command).languages
      if (commandInfo?.lang) {
        //存在缓存语言
        const languageInfo = this.languageList.find(item => item.key === commandInfo?.lang)
        if (languageInfo) {
          //和接口匹配
          this.language = commandInfo?.lang
        } else {
          //和接口不匹配
          this.language = this.languageList[0].key
        }
      } else {
        this.language = this.languageList[0].key
      }
      //时区
      this.timeZones = this.localesResult.find(item => item.country.key === command).timeZones
      if (commandInfo?.timeZone) {
        //存在缓存时区
        const zoneInfo = this.timeZones.find(item => item.key === commandInfo?.timeZone)
        if (zoneInfo) {
          //和接口匹配
          this.zone = commandInfo?.timeZone
        } else {
          //和接口不匹配
          this.zone = this.timeZones[0].key
        }
      } else {
        this.zone = this.timeZones[0].key
      }
      setLocal(
        LOCALE_STORE_KEY,
        { country: this.command, lang: this.language, timeZone: this.zone },
        { expire: 1000 * 60 * 60 * 24 * 365 }
      )
      window.location.reload()
    }
  },
  watch: {
    localesResult(value) {
      const locales = getLocal(LOCALE_STORE_KEY)
      this.command = locales.country
    }
  }
}
</script>

<style lang="stylus" scoped>
.dropdown {
  margin-right: 16px;
  cursor: pointer;
}
</style>
